import styled from 'styled-components';
import * as GStyled from '../../../styles/components';

const StyledFieldInfoTitle = styled(GStyled.Text).attrs(() => ({
  as: 'div',
  size: 'lg',
  color: 'pureBlack',
  fontWeight: 'medium',
}))`
  display: flex;
  align-items: center;

  > svg {
    margin-right: ${(props): string => props.theme.spaces.sm};
  }
`;

export default StyledFieldInfoTitle;
